import styled, { css } from 'styled-components';
import NextImage from 'next/image';

import ClearingButton from 'Campaigns/Clearing/Button';
import { Container as ArrowContainer } from 'Elements/Link/Arrow/Arrow.styled';

import NextLink from 'next/link';

export const Wrapper = styled.div`
    position: relative;
`;

export const Container = styled.div`
    ${({ theme }) => css`
        background: transparent
            linear-gradient(
                109deg,
                ${theme.colors.campaigns.clearing.primary.hex} 0%,
                ${theme.colors.accents[30].hex} 100%
            )
            0% 0% no-repeat padding-box;
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0.75rem;
        padding: 1rem;
        color: ${theme.colors.campaigns.clearing.primaryContrast.hex};
        height: 100%;
        border-radius: 0.5rem;
        flex-direction: column;

        @media ${theme.breakpoints.mediumSmall.media} {
            gap: 0.5rem;
            flex-direction: row;
        }

        @media ${theme.breakpoints.large.media} {
            gap: 1rem;
            background: transparent
                linear-gradient(
                    180deg,
                    ${theme.colors.campaigns.clearing.primary.hex} 0%,
                    ${theme.colors.accents[30].hex} 100%
                )
                0% 0% no-repeat padding-box;
            flex-direction: column;
            padding: 0 1rem 1.5rem;
            min-height: 18.25rem;
            margin-top: 9.25rem;
        }
    `}
`;

export const ImageWrapper = styled.div`
    position: absolute;
    top: -3.25rem;
    pointer-events: none;
`;

export const SauceImage = styled(NextImage)`
    ${({ theme }) => css`
        display: block;
        width: 3.5rem;
        height: 1.75rem;

        @media ${theme.breakpoints.large.media} {
            width: 4.375rem;
            height: 2.1875rem;
            max-width: 100%;
        }
    `}
`;

export const StyledImageForeground = styled(NextImage)<{ $isHovering: boolean }>`
    ${({ theme, $isHovering }) => css`
        display: none;
        z-index: 1;

        transition: transform 0.25s ease-in-out;

        @media ${theme.breakpoints.large.media} {
            display: block;
            position: absolute;
            left: 50%;
            top: 22%;
            transform: translate(-50%, -50%) ${$isHovering ? 'scale(0.95)' : 'scale(1)'};
            max-width: 100%;
        }
    `}
`;

export const StyledImageBg = styled(NextImage)<{ $isHovering: boolean }>`
    ${({ theme, $isHovering }) => css`
        display: none;
        transition: transform 0.25s ease-in-out;

        @media ${theme.breakpoints.large.media} {
            display: block;
            max-width: 100%;

            ${$isHovering &&
            css`
                transform: scale(1.05);
            `}
        }
    `}
`;

export const ImageBgWrapper = styled.div`
    overflow: hidden;
    border-radius: 0.5rem;
    width: 95%;
    margin: 0 auto;
`;

export const HeadingContainer = styled.div`
    ${({ theme }) => css`
        @media ${theme.breakpoints.large.media} {
            margin-top: 6rem;
        }
    `}
`;

export const PreHeading = styled.span`
    ${({ theme }) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: ${theme.fonts.secondary};
        font-style: italic;
        font-weight: 400;
        font-size: 1rem;
        line-height: 1;

        span {
            padding: 0 0.1rem 0.75rem 0.25rem;
            transform: rotate(-8deg);
        }

        @media ${theme.breakpoints.medium.media} {
            white-space: nowrap;
        }

        @media ${theme.breakpoints.large.media} {
            font-size: 1.25rem;
            text-align: center;
        }
    `}
`;

export const Heading = styled.h3`
    ${({ theme }) => css`
        margin: -0.5rem 0 0;
        font-size: 1.5rem;
        font-weight: 800;
        line-height: 1.3;
        text-align: center;

        @media ${theme.breakpoints.mediumSmall.media} {
            text-align: left;
        }

        @media ${theme.breakpoints.large.media} {
            text-align: center;
            margin: -0.5rem 0 0;
            font-size: 2.5rem;
        }
    `}
`;

export const StyledButton = styled(ClearingButton)`
    ${({ theme }) => css`
        padding: 0.75rem;
        margin: 0;
        font-weight: 400;
        font-size: 1rem;
        flex: 0 0 50%;

        @media ${theme.breakpoints.large.media} {
            padding: 1rem;
            font-size: 1.25rem;
            flex: 0 0 auto;
        }
    `}
`;

export const HiddenLink = styled(NextLink)`
    position: absolute;
    inset: 0;
`;

export const LinkWrapper = styled.div`
    ${({ theme }) => css`
        border-radius: 0.5rem;
        padding: 0.25rem 0.125rem 0.25rem 0.5rem;
        background: ${theme.colors.campaigns.clearing.primaryContrast.hex};

        ${ArrowContainer} {
            font-size: 1rem;
        }

        @media ${theme.breakpoints.mediumSmall.media} {
            padding: 0.5rem 0.25rem 0.5rem 1rem;
        }

        @media ${theme.breakpoints.medium.media} {
            ${ArrowContainer} {
                font-size: 1.125rem;
            }
        }

        @media ${theme.breakpoints.large.media} {
            text-align: center;
        }
    `}
`;
